import React from 'react';
import { resolveImageSrc, DEFAULT_AVATAR, avatarFallbackUrl } from '../utils/media';
import { ContactInfo, User } from '../types';

interface ProfileSectionProps {
  contactInfo: ContactInfo;
  user: User;
}

const ProfileSection: React.FC<ProfileSectionProps> = ({ contactInfo, user }) => {
  return (
    <div className="relative px-6 pt-4 pb-4">
      {/* Avatar positioned over cover image */}
      <div className="absolute -top-8 left-6">
        <div className="relative">
          <img
            src={(contactInfo as any)?.avatar ? resolveImageSrc(contactInfo.avatar) : avatarFallbackUrl(contactInfo?.name, (contactInfo as any)?.username)}
            alt={contactInfo.name}
            className="w-28 h-28 rounded-xl border-4 border-white shadow-xl object-cover"
            onError={(e) => { const img = e.currentTarget as HTMLImageElement; const fb = avatarFallbackUrl(contactInfo?.name, (contactInfo as any)?.username); if (img.src !== fb) img.src = fb; }}
          />
          {/* Company badge - positioned at bottom-left of avatar */}
          <div 
            className="absolute -bottom-2 -right-2 bg-red-800 text-white text-xs px-3 py-1 rounded font-semibold shadow-lg"
            style={{ backgroundColor: user.colors?.companyBadge || '#8B2635' }}
          >
            {(contactInfo.company || '').split(' ')[0] || 'Company'}
          </div>
        </div>
      </div>

      {/* Name and Title - positioned to the right of avatar and vertically centered */}
      <div className="ml-36 pt-0">
        <h1 
          className="text-xl font-bold leading-tight mb-1"
          style={{ color: user.colors?.text || '#1f2937' }}
        >
          {contactInfo.name}
        </h1>
        <p 
          className="text-sm font-medium"
          style={{ color: user.colors?.primary || '#3b82f6' }}
        >
          {user.position} at <span style={{ color: user.colors?.secondary || '#1e40af' }}>{user.company}</span>
        </p>
      </div>
    </div>
  );
};

export default ProfileSection;